import React from "react";
import { Link } from "react-router-dom";
import { CheckIcon, ArrowRightIcon } from "@heroicons/react/24/outline";

function PricingPage() {
  const countries = [
    { name: "United States", code: "US", cpm: 2.5, flag: "🇺🇸" },
    { name: "United Kingdom", code: "GB", cpm: 2.2, flag: "🇬🇧" },
    { name: "Germany", code: "DE", cpm: 2.0, flag: "🇩🇪" },
    { name: "France", code: "FR", cpm: 1.8, flag: "🇫🇷" },
    { name: "Canada", code: "CA", cpm: 2.0, flag: "🇨🇦" },
    { name: "Australia", code: "AU", cpm: 1.9, flag: "🇦🇺" },
    { name: "Türkiye", code: "TR", cpm: 0.8, flag: "🇹🇷" },
    { name: "Brazil", code: "BR", cpm: 0.6, flag: "🇧🇷" },
    { name: "India", code: "IN", cmp: 0.4, flag: "🇮🇳" },
    { name: "Philippines", code: "PH", cpm: 0.3, flag: "🇵🇭" },
  ];

  const features = [
    "Sınırsız link kısaltma",
    "Detaylı istatistikler",
    "API erişimi",
    "Custom link kodları",
    "Referans sistemi",
    "PayPal ödemeleri",
    "Mobile uyumlu panel",
    "24/7 destek",
  ];

  return (
    <div className="py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h1 className="text-4xl font-bold text-gray-900 mb-6">
            Kazanç Oranları
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Ülke bazlı CPM (1000 görüntüleme başına) oranlarımız. Her link
            tıklaması ile paranızı kazanın!
          </p>
        </div>

        {/* CPM Rates Table */}
        <div className="card mb-12">
          <div className="card-header">
            <h2 className="text-xl font-semibold text-gray-900">
              Ülke Bazlı Kazanç Oranları
            </h2>
          </div>
          <div className="card-body">
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead>
                  <tr className="border-b border-gray-200">
                    <th className="text-left py-3 px-4">Ülke</th>
                    <th className="text-center py-3 px-4">
                      CPM (1000 görüntüleme)
                    </th>
                    <th className="text-center py-3 px-4">Tık Başına</th>
                  </tr>
                </thead>
                <tbody>
                  {countries.map((country) => (
                    <tr
                      key={country.code}
                      className="border-b border-gray-100 hover:bg-gray-50"
                    >
                      <td className="py-3 px-4">
                        <div className="flex items-center space-x-3">
                          <span className="text-2xl">{country.flag}</span>
                          <span className="font-medium text-gray-900">
                            {country.name}
                          </span>
                          <span className="text-sm text-gray-500">
                            ({country.code})
                          </span>
                        </div>
                      </td>
                      <td className="text-center py-3 px-4 font-semibold text-green-600">
                        ${country.cpm?.toFixed(2)}
                      </td>
                      <td className="text-center py-3 px-4 text-gray-600">
                        ${(country.cpm / 1000)?.toFixed(4)}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* Features */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-12">
          <div className="card">
            <div className="card-header">
              <h2 className="text-xl font-semibold text-gray-900">
                Platform Özellikleri
              </h2>
            </div>
            <div className="card-body">
              <ul className="space-y-3">
                {features.map((feature) => (
                  <li key={feature} className="flex items-center space-x-3">
                    <CheckIcon className="w-5 h-5 text-green-500 flex-shrink-0" />
                    <span className="text-gray-700">{feature}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="card bg-gradient-to-r from-primary-50 to-blue-50 border-primary-200">
            <div className="card-header">
              <h2 className="text-xl font-semibold text-primary-900">
                Nasıl Kazanırım?
              </h2>
            </div>
            <div className="card-body">
              <div className="space-y-4">
                <div className="flex items-start space-x-3">
                  <div className="w-6 h-6 bg-primary-600 text-white rounded-full flex items-center justify-center text-sm font-bold flex-shrink-0">
                    1
                  </div>
                  <div>
                    <p className="font-medium text-gray-900">Hesap Oluşturun</p>
                    <p className="text-sm text-gray-600">
                      Ücretsiz hesabınızı oluşturun
                    </p>
                  </div>
                </div>
                <div className="flex items-start space-x-3">
                  <div className="w-6 h-6 bg-primary-600 text-white rounded-full flex items-center justify-center text-sm font-bold flex-shrink-0">
                    2
                  </div>
                  <div>
                    <p className="font-medium text-gray-900">Link Kısaltın</p>
                    <p className="text-sm text-gray-600">
                      URL'lerinizi kısaltın ve paylaşın
                    </p>
                  </div>
                </div>
                <div className="flex items-start space-x-3">
                  <div className="w-6 h-6 bg-primary-600 text-white rounded-full flex items-center justify-center text-sm font-bold flex-shrink-0">
                    3
                  </div>
                  <div>
                    <p className="font-medium text-gray-900">Para Kazanın</p>
                    <p className="text-sm text-gray-600">
                      Her tıklama ile para kazanın
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="text-center">
          <div className="card bg-gradient-to-r from-primary-600 to-purple-700 text-white">
            <div className="card-body py-12">
              <h2 className="text-3xl font-bold mb-4">Hemen Başlayın!</h2>
              <p className="text-blue-100 text-lg mb-8">
                Hesabınızı oluşturun ve linklerinizle para kazanmaya başlayın
              </p>
              <Link to="/register" className="btn btn-warning btn-xl">
                Ücretsiz Hesap Oluştur
                <ArrowRightIcon className="w-5 h-5 ml-2" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PricingPage;
